import {
  memo,
  type FC
} from 'react';
import {
  Box,
  Stack,
  Typography
} from '@mui/joy';

export const SuccessConfirmationMessage: FC = memo(() => (
  <Stack gap={1}>
    <Typography
      sx={({ palette }) => ({
        color: palette.common[700],
        fontSize: 20,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '30px',
      })}>
      Success!
    </Typography>
    <Typography
      sx={({ palette }) => ({
        color: palette.common[150],
        textAlign: 'left',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '20px',
      })}>
      Your email/phone was successfully verified and your
      account was awarded with:
    </Typography>
    <Stack
      direction='row'
      justifyContent='center'
      alignItems='center'
      gap={1}
      sx={({ palette }) => ({
        background: palette.common[475],
        borderColor: palette.common[925],
        borderStyle: 'solid',
        borderWidth: 1,
        width: '100%',
        paddingBlock: 1,
        paddingInline: 2,
        borderRadius: 8,
      })}>
      <Box
        component='img'
        loading='lazy'
        src='/assets/webp/sign_up_bonus.webp'
        width={22}
        height={28}
      />
      <Typography
        sx={({ palette }) => ({
          color: palette.common.white,
          fontSize: 14,
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
          '& span': { color: palette.common[1060] },
        })}>
        5,000 GC
      </Typography>
    </Stack>
  </Stack>
));